<div id="kt_app_toolbar" class="app-toolbar">
	<div id="kt_app_toolbar_container" class=" container-fluid d-flex flex-stack px-0 py-3">
		<div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
			<ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
				<li class="nav-item" *ngFor="let child of newsLetterDataChildren">
					<a class="nav-link text-active-primary ms-0 me-10" [routerLink]="['/common/news-letter/', child.path]" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
						{{ child.data?.navTitle }}
					</a>
				</li>
			</ul>
		</div>
		<!-- <div class="d-flex align-items-center gap-2 gap-lg-3">
			<a href="#" class="btn btn-sm fw-bold btn-secondary" data-bs-toggle="modal" data-bs-target="#kt_modal_create_app">Manage</a>
			<a href="#" class="btn btn-sm fw-bold btn-primary" data-bs-toggle="modal" data-bs-target="#kt_modal_new_target">Add New</a>
		</div>-->
	</div>
</div>

<router-outlet></router-outlet>
